////=require1 modules/_scroll-to.js

jQuery(function ($) {

    AOS.init();

    var mainSwiper = new Swiper('.main-swiper', {
        autoHeight: true,
        loop: true,
        lazy: {
            loadPrevNext: true,
            loadOnTransitionStart: true,
        },
        pagination: {
            el: ".swiper-pagination"
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoplay: {
            delay: 10000,
            disableOnInteraction: false,
        }
    });

    $('#mobile-panel-btn').on('click', function(e) {
        e.preventDefault();
        $('#mobile-panel').toggleClass('is-active');
    });

});